import { render, staticRenderFns } from "./IdentityTools.vue?vue&type=template&id=731f1334&lang=pug&"
import script from "./IdentityTools.vue?vue&type=script&lang=js&"
export * from "./IdentityTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports